import HubSpotClient from './clients/HubSpot/HubSpotClient';
import React from 'react';
import SearchPageState from './search/SearchPageState';
import smoothscroll from 'smoothscroll-polyfill';
import { defaultIfNone, HsContext } from './Utils';
import { HubSpotTabStateProvider } from './search/HubSpotTabStateProvider';
import { NavigationService } from './NavigationService';
import { SearchPage } from './search/SearchPage';
import { StorefrontClient } from './clients/Storefront/StorefrontClient';
import { StorefrontTabStateProvider } from './search/StorefrontTabStateProvider';
import { CookiePreferredStoreProvider } from './services/CookiePreferredStoreProvider';
import './App.css';

smoothscroll.polyfill();

export function debounce(callback: (x: any) => void, delay: number) {
  var timeout: NodeJS.Timeout;

  return function (x: any) {

    clearTimeout(timeout);

    timeout = setTimeout(function () {
      callback(x);
    }, delay);
  };
};


async function Bootstrap(context: HsContext) {
  const translations = defaultIfNone(context.translations);

  const portalId = "2778069";
  const entriesPerPage = 10;
  const hsClient = new HubSpotClient(portalId, 'https://api.hubapi.com/contentsearch/v2/search', context, entriesPerPage);
  const storefrontClient = new StorefrontClient(context, new CookiePreferredStoreProvider(), entriesPerPage, "png", 166, 255);
  const provider = new HubSpotTabStateProvider(hsClient, entriesPerPage);
  const storefrontProvider = new StorefrontTabStateProvider(storefrontClient, entriesPerPage);
  const searchPageState = new SearchPageState([storefrontProvider, provider], new NavigationService());

  function App() {
    return (<SearchPage state={searchPageState} translations={translations}/>
    );
  }

  return App;
}

export default Bootstrap;

